import React from "react";
import { Container } from "react-grid-system";

// STYLES
import styled from "styled-components";

// SHARED
import { Section } from "../../shared/shared";

// IMAGES
import El_tabua_1x from "../../images/network/el-ementa.png";
import El_tabua_2x from "../../images/network/el-ementa@2x.png";
import El_tabua_3x from "../../images/network/el-ementa@3x.png";

export default class Works extends React.PureComponent {
  render() {
    let { t } = this.props;

    return (
      <Section>
        <Container>
          <WorksContent>
            <ColLeft>
              <WorksTitle>{t("WorksTitle")}</WorksTitle>
              <WorksText>{t("WorksText1")}</WorksText>
              <WorksText>{t("WorksText2")}</WorksText>
              <WorksText>{t("WorksText3")}</WorksText>
              <WorksText>{t("WorksText4")}</WorksText>
              <WorksText>{t("WorksText5")}</WorksText>
              <WorksText>{t("WorksText6")}</WorksText>
            </ColLeft>
            <ColRight>
              <img
                src={El_tabua_1x}
                srcSet={[El_tabua_2x + " 1x, " + El_tabua_3x + " 2x"]}
                alt=""
              />
            </ColRight>
          </WorksContent>
          {/*
                    <a href="https://goo.gl/forms/N340hymUUWlsMu0r2" target="_blank">
                        <BtnBanner>REGULAMENTO</BtnBanner>
                    </a>
                    */}
        </Container>
      </Section>
    );
  }
}

const WorksContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ColLeft = styled.div``;
const ColRight = styled.div`
  text-align: right;

  img {
    width: 110%;
  }

  @media screen and (max-width: 992px) {
    display: none;
  }
`;
const WorksTitle = styled.h2`
  margin-top: 0;
  text-transform: uppercase;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 30px;
  line-height: 42px;
  text-align: left;
`;
const WorksText = styled.p`
  opacity: 0.8;
  font-size: 16px;
  line-height: 22px;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
`;



// WEBPACK FOOTER //
// ./src/components/works/works.component.js